import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; 
import 'swiper/css/effect-fade';
import { EffectFade, Autoplay, Pagination } from 'swiper/modules';
import { Link } from 'react-router-dom';

function Banner() {
    const [banners, setBanners] = useState([]);

    useEffect(() => {
        fetch('https://api.rvssoy.com/banners/read.php')
            .then(res => res.json())
            .then(data => {
                if(Array.isArray(data)) setBanners(data);
            })
            .catch(err => console.error(err));
    }, []);

    if (banners.length === 0) return null;

    return (
        <section className="banner-section-three">
            <Swiper
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                effect={'fade'}
                autoplay={{ delay: 3500, disableOnInteraction: false }}
                modules={[EffectFade, Autoplay, Pagination]}
            >
                {banners.sort((a,b) => a.display_order - b.display_order).map((banner) => (
                    <SwiperSlide key={banner.id}>
                        <div className="slide-item">
                            <div className="overlay-2" />
                            {/* Dinamik Şəkil */}
                            <div 
                                className="bg-image" 
                                style={{ backgroundImage: `url(${banner.image})` }} 
                            />
                            <div className="auto-container">
                                <div className="content-box">
                                    {/* Subtitle */}
                                    <span className="sub-title animate-2">{banner.sub_title}</span>
                                    
                                    {/* Title (HTML teqləri, məsələn <br/> işləsin deyə) */}
                                    <h1 
                                        className="title animate-3" 
                                        dangerouslySetInnerHTML={{ __html: banner.title }} 
                                    />
                                    
                                    {/* Düymə */}
                                    <div className="btn-box animate-4">
                                        <Link to={banner.btn_link || '/'} className="theme-btn btn-style-one hvr-light">
                                            <span className="btn-title">{banner.btn_text}</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}

export default Banner;